/* eslint-disable no-unused-vars */
import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Separator } from 'components';
import { FirstThreeItems } from './firstThreeItems/FirstThreeItems';
import { LastItem } from './lastItem/LastItem';
import { SelectedCreative } from './selectedCreative/SelectedCreative';
import { useSignal, useComputed } from '@preact/signals-react';
import { creativesActions } from 'store/campaign/creatives';
import { Plus } from 'assets/icons';
import { Buttons } from 'components';
import { getCreativeMessage } from 'store/selectors';

export const IsOngoingSection = ({
  creativeList$,
  addCreative,
  selectedCreativeItem$,
  environment,
  changeTabActionRef,
}) => {
  const currentCreativeName = useSelector((state) => state?.creatives?.selectedCreative?.name);
  const ctaTitle = useSelector((state) => state.creatives.selectedCreative?.title);

  const { fieldName, messageValue } = useSelector(getCreativeMessage);

  const dispatch = useDispatch();
  const handleCreativeChange = useCallback(
    (newValue) => {
      const newSelectedCreatives = creativeList$.value.find(
        ({ bn_bannerid }) => bn_bannerid === newValue,
      );
      dispatch(creativesActions.changeCreative(newSelectedCreatives));
    },
    [creativeList$],
  );

  const disabledBtn$ = useSignal(false);

  const separateCreatives$ = useComputed(() => {
    if (creativeList$.value.length < 4) {
      return { firstThreeItems: creativeList$.value, otherElements: [] };
    } else {
      return {
        firstThreeItems: creativeList$.value.slice(0, 3),
        otherElements: creativeList$.value.slice(3, creativeList$.value.length),
      };
    }
  });

  useEffect(() => {
    disabledBtn$.value =
      ctaTitle?.length < 2 || currentCreativeName?.length < 2 || messageValue?.length < 2;
  }, [ctaTitle?.length, currentCreativeName?.length, messageValue?.length]);

  return (
    <div>
      <div style={{ display: 'flex' }}>
        {useComputed(() => (
          <FirstThreeItems
            handleCreativeChange={handleCreativeChange}
            selectedBannerId={selectedCreativeItem$.value?.bn_bannerid}
            separateCreatives$={separateCreatives$}
          />
        ))}
        {useComputed(() => (
          <>
            {separateCreatives$.value.otherElements.length ? (
              <LastItem
                handleCreativeChange={handleCreativeChange}
                separateCreatives$={separateCreatives$}
                selectedBannerId={selectedCreativeItem$.value?.bn_bannerid}
                disabledBtn$={disabledBtn$}
              />
            ) : null}
          </>
        ))}
        <Buttons.SecondarySmall
          id='add_more_event'
          icon={<Plus />}
          onClick={addCreative}
          style={{ marginLeft: 'auto', paddingLeft: '8px', paddingRight: '8px' }}
          isDisabled={disabledBtn$.value}
        >
          Add
        </Buttons.SecondarySmall>
      </div>
      <Separator />
      <SelectedCreative
        selectedCreativeItem$={selectedCreativeItem$}
        environment={environment}
        changeTabActionRef={changeTabActionRef}
      />
    </div>
  );
};
